var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from "vuex";
import { Component, Watch } from 'vue-property-decorator';
import SystemSettingsService from '../../api/SystemSettingsService';
var Index = (function (_super) {
    __extends(Index, _super);
    function Index() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sortingSetting = [];
        _this.typeSortingDeliveryRule = 'sorting_delivery_rule';
        _this.typeSortingSplitRule = 'sorting_split_rule';
        _this.showTypeOnOff = false;
        return _this;
    }
    Index.prototype.created = function () {
        this.service = SystemSettingsService.getInstance();
    };
    Index.prototype.mounted = function () {
        this.getSortingSettings();
    };
    Index.prototype.onSortingSettingChange = function (newVal) {
        var _this = this;
        var sortingDeliveryRuleInfo = newVal.find(function (info) { return info.key === _this.typeSortingDeliveryRule; });
        if (sortingDeliveryRuleInfo) {
            this.showTypeOnOff = sortingDeliveryRuleInfo.value == 1;
            console.log('newVal=>>', sortingDeliveryRuleInfo.value, this.showTypeOnOff);
        }
    };
    Index.prototype.getSortingSettings = function () {
        var _this = this;
        this.service.getSortingSettings({}).then(function (res) {
            if (res.data && res.data.success) {
                var data = res.data.data;
                data.forEach(function (item, index) {
                    item.options_arr = [
                        1, 2
                    ];
                    _this.$set(_this.sortingSetting, index, item);
                });
            }
        });
    };
    Index.prototype.save = function () {
        var _this = this;
        var params = {};
        this.sortingSetting.forEach(function (item) {
            params[item.key] = item.value;
        });
        var sortingDeliveryRuleInfo = this.sortingSetting.find(function (info) { return info.key === _this.typeSortingDeliveryRule; });
        var sortingDeliveryRuleInfoORder = sortingDeliveryRuleInfo.options_list.find(function (info) { return info.key === 'sorting_delivery_rule_order'; });
        var sortingDeliveryRuleInfoOrderAutoYes = sortingDeliveryRuleInfoORder.options_list.find(function (info) { return info.key === 'sorting_delivery_rule_order_auto'; });
        params.sorting_delivery_rule_order_auto = sortingDeliveryRuleInfoOrderAutoYes.value;
        var sortingSplitRuleInfo = this.sortingSetting.find(function (info) { return info.key === _this.typeSortingSplitRule; });
        for (var i = 0; i < sortingSplitRuleInfo.options_list.length; i++) {
            params[sortingSplitRuleInfo.options_list[i].key] = sortingSplitRuleInfo.options_list[i].value;
        }
        delete params.sorting_split_rule;
        this.service.saveSortingSettings(params).then(function (res) {
            if (res.data && res.data.success) {
                _this.$message.success(res.data.msg || '保存成功');
            }
            else {
                _this.$message.error(res.data.msg);
            }
        });
    };
    __decorate([
        Watch("sortingSetting", { deep: true, immediate: true })
    ], Index.prototype, "onSortingSettingChange", null);
    Index = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user",
                openedCodeData: 'openedCodeData'
            }))
        })
    ], Index);
    return Index;
}(Vue));
export default Index;
